import React from "react";

// Compact, scalable monogram of the Imperial Landscaping, TLH brand.
// Matches /favicon.svg so tab icon + nav + footer share one visual identity.
export const BrandMark = ({ className = "w-12 h-12", dotRing = "#0F1F15" }) => (
  <svg
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <defs>
      <linearGradient id="bm-grass" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#5fa66f" />
        <stop offset="1" stopColor="#1f4429" />
      </linearGradient>
      <linearGradient id="bm-gold" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#FDE68A" />
        <stop offset="0.5" stopColor="#EAB308" />
        <stop offset="1" stopColor="#A16207" />
      </linearGradient>
    </defs>
    <rect width="64" height="64" rx="14" fill="#0F1F15" />
    <rect x="3" y="3" width="58" height="58" rx="11" fill="url(#bm-grass)" />
    <text
      x="32"
      y="46"
      textAnchor="middle"
      fontFamily="Georgia, 'Times New Roman', serif"
      fontWeight="900"
      fontSize="38"
      fill="url(#bm-gold)"
      stroke="#0F1F15"
      strokeWidth="2.2"
      paintOrder="stroke"
      letterSpacing="-1"
    >
      IL
    </text>
    <circle cx="52" cy="12" r="5" fill="#EAB308" stroke={dotRing} strokeWidth="1.5" />
  </svg>
);
